module.exports = __webpack_public_path__ + "static/media/feed.391bc333.svg";